import { GridRow } from "../../../../api/generated/data-contracts";
import { createContext } from "../../../../hooks/createContext";

export type RowContext = {
    row: GridRow;
	toggleExpanded: (toggle?: boolean) => void;
	getRowAncestorTreeToRoot: (rowId: string) => GridRow[];
	nestingLevel: number;
	subRows: GridRow[];
	rowRelations: GridRow[];
	canExpand: boolean;
	visible: boolean;
	rowIndex: number
};

const [useCtx, Provider] = createContext<RowContext>();

export const useGridRowContext = useCtx;

export const GridRowContext = Provider;